import { Trans, useTranslation } from 'react-i18next';

import useResetPasswordForm from './useResetPasswordForm';
import TextField from '../UI/TextField';
import Button from '../UI/Button';
import styles from './ResetPasswordForm.module.scss';

interface ResetPasswordFormProps {
  prefillIdentification?: string | null;
}

const ResetPasswordForm = ({ prefillIdentification }: ResetPasswordFormProps) => {
  const { t } = useTranslation();
  const {
    register,
    handleSubmit,
    onSubmit,
    confirmPrefill,
    errors,
    isRequestSent,
    resetFormState,
    isLoading,
    apiError,
    prefill,
    identification,
    isEmailIdentification,
  } = useResetPasswordForm(prefillIdentification);

  return (
    <div className="request-password-reset">
      {isRequestSent ? (
        <div>
          <h1 className="h3">
            {t(isEmailIdentification
              ? 'resetPasswordForm.successTitle'
              : 'resetPasswordForm.successTitleUsername')}
          </h1>
          {isEmailIdentification ? (
            <>
              <p className="body-small">
                <Trans i18nKey="resetPasswordForm.successMessage" values={{ email: identification }}
                  components={{ strong: <strong/> }}
                />
              </p>
              <p className="body-small">{t('resetPasswordForm.spamCheckMessage')}</p>
            </>
          ) : (
            <>
              <p className="body-small">
                <Trans i18nKey="resetPasswordForm.successMessageUsername"
                  values={{ identification }}
                  components={{ strong: <strong/> }}
                />
              </p>
              <p className="body-small">{t('resetPasswordForm.spamCheckMessageUsername')}</p>
            </>
          )}
          <p className="body-small">
            <Trans
              i18nKey="resetPasswordForm.accountResetNote"
              components={[<a href="https://www.cyclomedia.com/us/support/contactservice-desk"/>]}
            />
          </p>
          {isEmailIdentification ? (
            <Button onClick={resetFormState}>
              {t('resetPasswordForm.goBackButton')}
            </Button>
          ) : (
            <p className="body-small">{t('resetPasswordForm.closePageMessage')}</p>
          )}
        </div>
      ) : prefill ? (
        <>
          <h1 className="h3">{t('resetPasswordForm.title')}</h1>
          <p className="body-small">
            <Trans
              i18nKey="resetPasswordForm.confirmPrefillMessage"
              values={{ identification: prefill }}
              components={{ strong: <strong /> }}
            />
          </p>
          {!!apiError && <span className={styles.errorMessage}>{apiError}</span>}
          <div className={styles.formNavigation}>
            <Button onClick={confirmPrefill} disabled={isLoading}>
              {t('resetPasswordForm.okButton')}
            </Button>
          </div>
        </>
      ) : (
        <>
          <h1 className="h3">{t('resetPasswordForm.title')}</h1>
          <p className="body-small">{t('resetPasswordForm.description')}</p>

          <form className={styles.form} onSubmit={handleSubmit(onSubmit)}>
            <div className={styles.formFields}>
              <TextField
                label="Email"
                {...register('emailAddress')}
                autoComplete="off"
                error={!!errors.emailAddress?.message}
                supportingText={errors.emailAddress}
              />
              {!!apiError && <span className={styles.errorMessage}>{apiError}</span>}
            </div>
            <div className={styles.formNavigation}>
              <Button type="submit" disabled={isLoading}>{t('resetPasswordForm.submitButton')}</Button>
            </div>
          </form>
        </>
      )}
    </div>
  );
};

export default ResetPasswordForm;
